import React from 'react';
import { Currency } from 'ui-toolkit';

export interface IBaseStatusPillProps {
  status: 'Staged' | 'Initiated' | 'Disbursed' | 'Holdback' | 'Void' | 'Auto-Void' | 'Printed';
  text: string;
  amountCents?: number;
  id: string;
  title?: string;
  hasWarning: boolean;
  href?: string;
}

const pillColors = {
  Staged: 'bg-yellow-100 text-yellow-800',
  Initiated: 'bg-blue-100 text-blue-800',
  Disbursed: 'bg-green-100 text-green-800',
  Holdback: 'bg-red-50 text-red-800',
  Void: 'bg-red-100 text-red-800',
  Printed: 'bg-orange-100 text-orange-800',
  'Auto-Void': 'bg-red-100 text-red-800',
};

export const BaseStatusPill: React.FC<IBaseStatusPillProps> = ({
  status,
  text,
  amountCents,
  id,
  title,
  hasWarning,
  href,
}) => {
  const className = `${pillColors[status]} ${
    hasWarning ? 'border-2 border-red-600' : ''
  } h-fit gap-1 whitespace-nowrap rounded-full px-2 py-1 align-middle text-xs font-medium `;
  if (href) {
    <a
      key={id}
      href={href}
      target={'_blank'}
      rel={'noreferrer'}
      data-test-id={`${text.toLowerCase()}-status-pill-${id}`}
      className={className}
      title={title}
    >
      {text}: {status}
      <br />
      <div className={'text-right'}>{amountCents !== undefined && <Currency value={amountCents} valueIsCents />}</div>
    </a>;
  }

  return (
    <div key={id} data-test-id={`${text.toLowerCase()}-status-pill-${id}`} className={className} title={title}>
      {text}: {status}
      <br />
      <div className={'text-right'}>{amountCents !== undefined && <Currency value={amountCents} valueIsCents />}</div>
    </div>
  );
};
